// tslint:disable
export var MessageContentType;
(function (MessageContentType) {
    // HTML
    MessageContentType[MessageContentType["Html"] = 1] = "Html";
    // Text
    MessageContentType[MessageContentType["Text"] = 2] = "Text";
})(MessageContentType || (MessageContentType = {}));
MessageContentType['HTML'] = 1;
MessageContentType['TEXT'] = 2;
//# sourceMappingURL=MessageContentType.js.map